<template lang="pug">
  div.map-container.navigation-control
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Карта
        form.search
          input(type="search" placeholder="Введите № автомобиля")

    div.new-map
      div.map-route-popup.map-route-popup--warning
        div Мусоровоз № 353
        div Отставание от графика на 1 час
        span.close--small

      div#map.bigmap
      transition(name="fade")
        div.legend.cuscroll(:class="showRight ? 'open' : 'close'")
          div.head(@click="showRight = !showRight")
            h2.title Сейчас на линии
            div.legend-info 58 из 63 машин
            // span.legend__close(v-if="showRight")
            //span.legend__open(v-else)
          div.type-group
            div.group.flex
              div.type
                div.marker.active
                  a(href="/#/verstka/navigation-control-car") Мусоровоз №1 ( Г153ОР86RUS)
                  div.progress
                    div.progress-loaded(style="width: 33%")

              div.type
                div.marker.inactive
                  span Мусоровоз №1 ( Г153ОР86RUS)
                  div.progress
                    div.progress-loaded(style="width: 60%")

              div.type
                div.marker.planned
                  span Мусоровоз №1 ( Г153ОР86RUS)
                  div.progress
                    div.progress-loaded(style="width: 60%")

          div.type-group
            div.group.info
              div.type
                span.marker.active На линии
              div.type
                span.marker.inactive На ремонте
              div.type
                span.marker.planned Недоступен


</template>

<script>
  import 'leaflet';

  window.L = L;

  export default {
    data() {
      return {
        showRight: true,
        map: [],
        markers: null
      };
    },
    methods: {
      initmap3() {
        this.map = L.map('map', {
          center: [56.84325131, 60.60611655],
          zoom: 17
        });
        L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(this.map);
      }
    },
    mounted() {
      this.$store.dispatch('initelements');
      this.initmap3();
    }
  };
</script>

<style lang="scss">
  @import "../../../../node_modules/leaflet/dist/leaflet.css";
</style>
